export default __webpack_public_path__ + "static/media/bankVerificationhelpHighlight.77ad4c60.png";